import { cusAxios, PREFIX } from './main';

const getGamesUsers = async ({ groupId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/gamestat/user_list`,
    data: { groupId }
  });
  return response;
};

const getSource = async () => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/gamestat/source_list`
  });
  return response;
};

const getProvider = async ({ sourceId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/gamestat/provider_list`,
    data: { sourceId }
  });
  return response;
};

const getReportStatistic = async (data) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/gamestat/report`,
    data: data
  });
  return response;
};

export const API_GAMES = {
  list: { users: getGamesUsers, source: getSource, providers: getProvider },
  report: {
    statistic: getReportStatistic
  }
};
